
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student-discount",
      function () {
        return require("private-next-pages/student-discount/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student-discount"])
      });
    }
  